import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";

const loadImg = async (url) => {
  const { data } = await api.get(url.replace(/^\/api/, ""), { responseType: "blob" });
  const img = new Image();
  img.src = URL.createObjectURL(data);
  await img.decode();
  return img;
};

// Loads each month's Joy Snaps (as drawable images) for the year video; null while loading.
export const useJoySnaps = (y) => {
  const [joy, setJoy] = useState(null);
  useEffect(() => {
    let alive = true;
    const keys = y.months.map((m) => m.month_key);
    (async () => {
      try {
        const { data } = await api.get("/joy-snaps/range", { params: { start: keys[0], end: keys[keys.length - 1] } });
        const months = await Promise.all(data.months.map(async (m) => {
          const photos = (await Promise.all(m.snaps.map(async (s) => {
            try { return { caption: s.caption, img: await loadImg(s.url) }; } catch { return null; }
          }))).filter(Boolean);
          return { label: m.label, count: m.count, photos };
        }));
        if (alive) setJoy(months.filter((m) => m.photos.length));
      } catch (e) { logError("Joy snaps for video failed:", e); if (alive) setJoy([]); }
    })();
    return () => { alive = false; };
  }, [y]);
  return joy;
};
